async function getAPIResponse(apiURL, callback) {
  try {
    const response = await fetch(apiURL, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // Use the 'data' variable here

    // Call the provided callback function to update the DOM
    if (data) {
      callback(data);
      document.querySelector(".loader-container").style.display = "none";
    }
  } catch (error) {
    //console.log("Error:", error);
  }
}

function updateHeader(data) {
  // Find the element with the class "navbar-nav"
  const navbarNav = document.querySelector(".navbar-nav");

  if (data) {
    data.forEach((item) => {
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.classList.add("nav-link");
      a.href = item.urlWithDomain;
      a.textContent = item.title;

      // Check if the item has children
      if (item.title === "My Stable") {
        if (typeof ShopifyAnalytics.meta.page.customerId !== "undefined") {
          // The user is logged in, and you can access the customer id
          li.classList.add("nav-item");
          a.classList.add("nav-link");
          a.href = item.urlWithDomain;
          a.setAttribute("role", "button");
          a.textContent = item.title;
          li.appendChild(a);
        }
      } else if (item.childrens && item.childrens.length > 0) {
        li.classList.add("nav-item", "dropdown", "user-dropdown-menu");
        a.classList.add("dropdown-toggle");
        a.setAttribute("role", "button");
        a.setAttribute("data-bs-toggle", "dropdown");
        a.setAttribute("aria-expanded", "false");

        // Create dropdown menu
        const dropdownMenuDiv = document.createElement("div");
        dropdownMenuDiv.classList.add("dropdown-menu");
        dropdownMenuDiv.setAttribute(
          "aria-labelledby",
          "collapsible-nav-dropdown"
        );

        // Loop through the children and create dropdown items
        item.childrens.forEach((child) => {
          const dropdownItem = document.createElement("a");
          dropdownItem.classList.add("dropdown-item");
          dropdownItem.setAttribute("href", child.urlWithDomain);
          dropdownItem.textContent = child.title;
          dropdownMenuDiv.appendChild(dropdownItem);
        });

        li.appendChild(a);
        li.appendChild(dropdownMenuDiv);
      } else if (item.isShop && item.products && item.products.length > 0) {
        li.classList.add("nav-item", "dropdown", "product-card-menu");
        // const dropdownDiv = document.getElementById("cardItems");
        const dropdownMenu = document.getElementById("cardItems");

        a.classList.add("nav-link", "dropdown-toggle");
        a.href = "#";
        a.setAttribute("role", "button");
        a.setAttribute("data-bs-toggle", "dropdown");
        a.setAttribute("aria-expanded", "false");
        a.textContent = item.title;
        li.appendChild(a);
        console.log("before ");
        item.products.forEach((product) => {
          const productHTML = `
            <div class="product-card white card">
            <a  href="${product.urlWithDomain}">
              <picture>
                <source
                  media="(min-width: 820px)"
                  srcset="${product.image}"
                >
                <img
                  src="${product.image}"
                  alt="${product.imageAltText}"
                  class="img-fluid"
                >
              </picture>
              </a>
              <div class="card-body">
              
                <a  href="${product.urlWithDomain}"><h3 class="card-title">${
            product.title
          }</h3></a>
            <div>
   
                 ${
                   // Create and configure the bodyHtml element
                   (() => {
                     const bodyHtml = document.createElement("p");
                     bodyHtml.classList.add("card-text");
                     bodyHtml.innerHTML = product.bodyHtml;
                     return bodyHtml.outerHTML; // Convert the element to its HTML representation
                   })()
                 }
              
              </div>
                
                <a class="btn btn-link" href="${
                  product.urlWithDomain
                }">Shop Now <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa fa-chevron-right " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path></svg></a>
              </div>
            </div>
          `;
          dropdownMenu.insertAdjacentHTML("beforeend", productHTML);
        });

        li.appendChild(dropdownMenu);
      } else {
        li.classList.add("nav-item");
        li.appendChild(a);
      }

      navbarNav.appendChild(li);
    });
  }
}

function updateFooter(data) {
  // Find the element with the class "footer-nav"
  const navbarNav = document.querySelector(".footer-nav");

  if (data) {
    data.forEach((item) => {
      const li = document.createElement("li");
      const a = document.createElement("a");
      li.classList.add("nav-item");
      a.classList.add("nav-link");
      a.href = item.urlWithDomain;
      a.setAttribute("role", "button");
      a.textContent = item.title;
      li.appendChild(a);
      navbarNav.appendChild(li);
    });
  }
}

function PageConfigurations(data) {
  // Find the <ul> element with the class "footer-links"
  //var $ul = $('.footer-links');
  const navbarNav = document.querySelector(".footer-links");
  const mainLogo = document.getElementsByClassName("header__heading-logo");
  const footerLogo = document.getElementsByClassName("footer-logo");
  const copyRightText = document.getElementsByClassName("js-copyRightText");
  if (data) {
    // const ul = document.createElement("ul");
    // ul.classList.add("footer-links", "ustify-content-end", "nav");
    // Main Logo
    mainLogo.src = data.headerLogo;
    mainLogo.alt = data.headerLogoAltText;

    // Footer logo
    footerLogo.src = data.footerLogo;
    footerLogo.alt = data.footerLogoAltText;

    // Copy Right Text
    copyRightText.textContent = data.copyRightText;

    // Create list elements for the specified properties
    const properties = [
      "myPersonalInformationText",
      "smsTerms",
      "privacyTerms",
      "caSupplyChain",
    ];
    var listItemsHtml = "";
    function isValid(value) {
      return value && value !== "#" && value !== "";
    }

    // if (data.myPersonalInformationText && isValid(data.myPersonalInformationUrl)) {
    //     listItemsHtml += `<li class="nav-item"><a class="nav-link" href="${data.myPersonalInformationUrl}" target="${data.myPersonalInformationUrlTarget}">${data.myPersonalInformationText}</a></li>`;
    // }
    // if (data.privacyTerms && isValid(data.privacyTermsUrl)) {
    //     listItemsHtml += `<li class="nav-item"><a class="nav-link" href="${data.privacyTermsUrl}" target="${data.privacyTermsUrlTarget}">${data.privacyTerms}</a></li>`;
    // }
    // if (data.smsTerms && isValid(data.smsTermsUrl)) {
    //     listItemsHtml += `<li class="nav-item"><a class="nav-link" href="${data.smsTermsUrl}" target="${data.smsTermsUrlTarget}">${data.smsTerms}</a></li>`;
    // }
    // if (data.caSupplyChain && isValid(data.caSupplyChainUrl)) {
    //     listItemsHtml += `<li class="nav-item"><a class="nav-link" href="${data.caSupplyChainUrl}" target="${data.caSupplyChainUrlTarget}">${data.caSupplyChain}</a></li>`;
    // }
    // $ul.html(listItemsHtml);
    //navbarNav.appendChild(listItemsHtml);
    properties.forEach((property) => {
      const li = document.createElement("li");
      const a = document.createElement("a");

      li.classList.add("nav-item");
      a.classList.add("nav-link");
      a.href = data[`${property}Url`]; // Use the URL property from the API data
      a.textContent = data[property]; // Use the text property from the API data
      a.target = data[`${property}UrlTarget`]; // Use the target property from the API data

      li.appendChild(a);
      navbarNav.appendChild(li);
    });
  }
}
function CallAdobe(data) {
  if (data.pageType != null) {
    window.adobeDataLayer = window.adobeDataLayer || [];
  // Function to push the Adobe URL data to Adobe Data Layer
  function pushAdobeUrlEvent() {
    window.adobeDataLayer.push({
      event: 'adobeUrlLoaded',
      adobeUrl: data.url, // Assuming 'url' is the key for Adobe URL in your API response
    });
  }

  // Call the function to push Adobe URL event to Data Layer
  pushAdobeUrlEvent();
  }
  else
  {
    console.log("else")
  }
  
  
}

// Call the API function when the DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  const pathname = window.location.pathname;
  const apiURL = `https://apidv.purinaequinemq.com/api/PageConfiguration/AdobeUrl?url=${encodeURIComponent(pathname)}`;
  getAPIResponse(
    "https://apidv.purinaequinemq.com/api/Navigation/navigationByMenuGroup/header",
    updateHeader
  );
  getAPIResponse(
    "https://apidv.purinaequinemq.com/api/Navigation/navigationByMenuGroup/footer",
    updateFooter
  );
  getAPIResponse(
    "https://apidv.purinaequinemq.com/api/PageConfiguration/PageConfigurations",
    PageConfigurations
  );
  getAPIResponse(
    apiURL,
    CallAdobe
  );
});
